export default "__VITE_ASSET__DcoxNhlH__"